var _path;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
var SvgSsoreact = function SvgSsoreact(_ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 19,
    height: 18,
    fill: "none",
    viewBox: "0 0 19 18",
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#3B72A7",
    fillRule: "evenodd",
    d: "M9.5 18a9 9 0 1 0 0-18 9 9 0 0 0 0 18m1.765-7.53A3.235 3.235 0 1 0 8.23 8.364l-3.617 3.476a.37.37 0 0 0-.114.27v1.51c0 .21.175.38.39.38h1.303c.215 0 .39-.17.39-.38v-.74h.757c.215 0 .39-.17.39-.38v-.741h.796c.104 0 .202-.04.275-.112l1.373-1.364c.34.122.708.189 1.09.189m0-1.764a1.47 1.47 0 1 0 0-2.941 1.47 1.47 0 0 0 0 2.941",
    clipRule: "evenodd"
  })));
};
export default SvgSsoreact;